import { render } from "./RebiddingTenderPopup.vue?vue&type=template&id=0bb1c053"
import script from "./RebiddingTenderPopup.vue?vue&type=script&lang=js"
export * from "./RebiddingTenderPopup.vue?vue&type=script&lang=js"

import exportComponent from "/srv/www/nahodka.xpage.dev/htdocs/public/local/client-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__